/** Tenant-only opt-in. Missing, global or unreadable rows keep today's import. */
export const ROSTER_IMPORT_V2_FLAG = 'roster_import_v2_v1';
export function isTenantScopedRosterImportV2Flag(key: string | null | undefined): boolean {
  return key === ROSTER_IMPORT_V2_FLAG;
}
